"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Variant = exports.Fallback = exports.Control = void 0;
var _react = _interopRequireWildcard(require("react"));
var _provider = require("../provider");
var _tracking = require("../utils/tracking");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Variant = function Variant(_ref) {
  var children = _ref.children;
  return children;
};
exports.Variant = Variant;
Variant.defaultProps = {
  value: 'control'
};
var Control = Variant;
exports.Control = Control;
var Fallback = function Fallback(_ref2) {
  var children = _ref2.children;
  return children;
};
exports.Fallback = Fallback;
var renderedExperimentIds = [];
var Experiment = function Experiment(_ref3) {
  var id = _ref3.id,
    children = _ref3.children;
  var experiences = (0, _provider.useExperiences)();
  if (!experiences) {
    // eslint-disable-next-line no-console
    console.error('You have tried to use the Experiment component without first adding ExperienceProvider context - Please use react-chansey/provider component within your application first.');
    return null;
  }
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    trackEvents = _useState2[0],
    setTrackEvents = _useState2[1];
  (0, _react.useEffect)(function () {
    setTrackEvents((0, _tracking.shouldTrack)(id, renderedExperimentIds));
  }, []);
  var experience = experiences[id];
  var variant = String(experience === null || experience === void 0 ? void 0 : experience.value);
  var fallbackComponent = _react["default"].Children.toArray(children).find(function (child) {
    return child.type.name === Fallback.name;
  });
  var variantComponent = _react["default"].Children.toArray(children).find(function (v) {
    return String(v.props.value) === variant;
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, experience && (experience.recording === undefined || experience.recording) && trackEvents && /*#__PURE__*/_react["default"].createElement("div", {
    "data-nerd": true,
    "data-nerd-type": "experiment",
    "data-nerd-props": JSON.stringify({
      experiment_id: id,
      iteration_id: experience.iteration || '1',
      variation_id: variant
    }),
    "data-nerd-observable": true,
    "data-nerd-loaded": true
  }), variantComponent || fallbackComponent);
};
var _default = Experiment;
exports["default"] = _default;